"use client";
import { cn } from "@/lib/utils";
import React, { ReactNode } from "react";

interface AuroraBackgroundProps extends React.HTMLProps<HTMLDivElement> {
    children: ReactNode;
    showRadialGradient?: boolean;
}

export const AuroraBackground = ({
    className,
    children,
    showRadialGradient = true,
    ...props
}: AuroraBackgroundProps) => {
    return (
        <main>
            <div
                className={cn(
                    "transition-bg relative flex h-[100vh] flex-col items-center justify-center text-slate-950 bg-zinc-900",
                    className,
                )}
                {...props}
            >
                <div
                    className="absolute inset-0 overflow-hidden"
                    style={
                        {
                            "--aurora":
                                "repeating-linear-gradient(100deg,#bfa76a_10%,#a19b92_20%,#fff_30%,#6e6259_40%,#23211c_50%)",
                            "--dark-gradient":
                                "repeating-linear-gradient(100deg,#23211c_0%,#23211c_7%,transparent_10%,transparent_12%,#23211c_16%)",
                            "--white-gradient":
                                "repeating-linear-gradient(100deg,#fff_0%,#fff_7%,transparent_10%,transparent_12%,#fff_16%)",

                            "--gold": "#bfa76a",
                            "--beige": "#a19b92",
                            "--white": "#000",
                            "--brown": "#6e6259",
                            "--dark": "#23211c",
                            "--transparent": "transparent",
                        } as React.CSSProperties
                    }
                >
                    <div
                        className={cn(
                            `aurora-animate after:animate-aurora pointer-events-none absolute -inset-[10px] [background-image:var(--white-gradient),var(--aurora)] [background-size:300%,_200%] [background-position:50%_50%,50%_50%] opacity-30 blur-[15px] invert filter will-change-transform [--aurora:repeating-linear-gradient(100deg,var(--gold)_10%,var(--beige)_20%,var(--white)_30%,var(--brown)_40%,var(--dark)_50%)] [--dark-gradient:repeating-linear-gradient(100deg,var(--dark)_0%,var(--dark)_7%,var(--transparent)_10%,var(--transparent)_12%,var(--dark)_16%)] [--white-gradient:repeating-linear-gradient(100deg,var(--white)_0%,var(--white)_7%,var(--transparent)_10%,var(--transparent)_12%,var(--white)_16%)] after:absolute after:inset-0 after:[background-image:var(--white-gradient),var(--aurora)] after:[background-size:200%,_100%] after:[background-attachment:fixed] after:mix-blend-difference after:content-[''] dark:[background-image:var(--dark-gradient),var(--aurora)] dark:invert-0 after:dark:[background-image:var(--dark-gradient),var(--aurora)]`,
                            showRadialGradient &&
                            `[mask-image:radial-gradient(ellipse_at_100%_0%,black_10%,var(--transparent)_70%)]`,
                        )}
                    ></div>
                </div>
                {children}
            </div>
        </main>
    );
};
